import styles from '../index.module.less'
import { Card } from '@modules/missions/keaz/step/components/card'
import { PhotoView } from '@modules/missions/keaz/step/components/photoView'
import { FormGroup } from '@modules/missions/keaz/step/components/formGroup'
import { Checkbox } from '@smwb/summer-ui/dist/connects/rff'
import {
  MechanicalStepCoolingSystemCheck,
  MechanicalStepCoolingSystemCheckFields
} from '@modules/missions/keaz/types'
import { DeviationsFormFields } from '@modules/missions/keaz/step/components/contentBySteps/components/deviationsFormFields'
import { StepForm } from '@modules/missions/keaz/step/components/stepForm'
import React from 'react'
import { ErrorMessage } from '@modules/missions/keaz/step/components/contentBySteps/components/errorMessage'

export interface CoolingSystemCheckProps {
  compact: boolean
  step: MechanicalStepCoolingSystemCheck
  isEditableStep: boolean
  setCompact: React.Dispatch<React.SetStateAction<boolean>>
  onBackClick: () => void
  refetchReports: () => void
}

export function CoolingSystemCheck({
  compact,
  step,
  isEditableStep,
  setCompact,
  onBackClick,
  refetchReports
}: CoolingSystemCheckProps) {
  return (
    <div>
      <StepForm<MechanicalStepCoolingSystemCheck>
        step={step}
        compact={compact}
        isEditableStep={isEditableStep}
        setCompact={setCompact}
        onBackClick={onBackClick}
        refetchReports={refetchReports}
      >
        <FormGroup compact={compact}>
          <Card className={styles.card}>
            <Checkbox
              name={MechanicalStepCoolingSystemCheckFields.hoseConnectionLeakCheckPoint1}
              label='Проверка на течь соединения шлангов в точке №1 проведена'
              disabled={compact}
            />

            <ErrorMessage
              fieldName={MechanicalStepCoolingSystemCheckFields.hoseConnectionLeakCheckPoint1}
              className={styles.errorMessage}
            />
          </Card>
        </FormGroup>

        <FormGroup compact={compact}>
          <Card className={styles.card}>
            <PhotoView<MechanicalStepCoolingSystemCheck>
              compact={compact}
              title='Фото соединения шлангов в точке №1'
              fieldName={MechanicalStepCoolingSystemCheckFields.hoseConnectionPhotoPoint1}
            />
          </Card>
        </FormGroup>

        <FormGroup compact={compact}>
          <Card className={styles.card}>
            <PhotoView<MechanicalStepCoolingSystemCheck>
              compact={compact}
              title='Фото соединения шлангов в точке №1 после замены'
              fieldName={
                MechanicalStepCoolingSystemCheckFields.hoseConnectionReplacementPhotoPoint1
              }
            />
          </Card>
        </FormGroup>

        <FormGroup compact={compact}>
          <Card className={styles.card}>
            <Checkbox
              name={MechanicalStepCoolingSystemCheckFields.hoseConnectionLeakCheckPoint2}
              label='Проверка на течь соединения шлангов в точке №2 проведена'
              disabled={compact}
            />

            <ErrorMessage
              fieldName={MechanicalStepCoolingSystemCheckFields.hoseConnectionLeakCheckPoint2}
              className={styles.errorMessage}
            />
          </Card>
        </FormGroup>

        <FormGroup compact={compact}>
          <Card className={styles.card}>
            <PhotoView<MechanicalStepCoolingSystemCheck>
              compact={compact}
              title='Фото соединения шлангов в точке №2'
              fieldName={MechanicalStepCoolingSystemCheckFields.hoseConnectionPhotoPoint2}
            />
          </Card>
        </FormGroup>

        <FormGroup compact={compact}>
          <Card className={styles.card}>
            <PhotoView<MechanicalStepCoolingSystemCheck>
              compact={compact}
              title='Фото соединения шлангов в точке №2 после замены'
              fieldName={
                MechanicalStepCoolingSystemCheckFields.hoseConnectionReplacementPhotoPoint2
              }
            />
          </Card>
        </FormGroup>

        <FormGroup compact={compact}>
          <Card className={styles.card}>
            <Checkbox
              name={MechanicalStepCoolingSystemCheckFields.hoseConnectionLeakCheckPoint3}
              label='Проверка на течь соединения шлангов в точке №3 проведена'
              disabled={compact}
            />
          </Card>
        </FormGroup>

        <FormGroup compact={compact}>
          <Card className={styles.card}>
            <PhotoView<MechanicalStepCoolingSystemCheck>
              compact={compact}
              title='Фото соединения шлангов в точке №3'
              fieldName={MechanicalStepCoolingSystemCheckFields.hoseConnectionPhotoPoint3}
            />
          </Card>
        </FormGroup>

        <FormGroup compact={compact}>
          <Card className={styles.card}>
            <PhotoView<MechanicalStepCoolingSystemCheck>
              compact={compact}
              title='Фото соединения шлангов в точке №3 после замены'
              fieldName={
                MechanicalStepCoolingSystemCheckFields.hoseConnectionReplacementPhotoPoint3
              }
            />
          </Card>
        </FormGroup>

        <FormGroup compact={compact}>
          <Card className={styles.card}>
            <Checkbox
              name={MechanicalStepCoolingSystemCheckFields.hoseConnectionLeakCheckPoint4}
              label='Проверка на течь соединения шлангов в точке №4 проведена'
              disabled={compact}
            />

            <ErrorMessage
              fieldName={MechanicalStepCoolingSystemCheckFields.hoseConnectionLeakCheckPoint4}
              className={styles.errorMessage}
            />
          </Card>
        </FormGroup>

        <FormGroup compact={compact}>
          <Card className={styles.card}>
            <PhotoView<MechanicalStepCoolingSystemCheck>
              compact={compact}
              title='Фото соединения шлангов в точке №4'
              fieldName={MechanicalStepCoolingSystemCheckFields.hoseConnectionPhotoPoint4}
            />
          </Card>
        </FormGroup>

        <FormGroup compact={compact}>
          <Card className={styles.card}>
            <PhotoView<MechanicalStepCoolingSystemCheck>
              compact={compact}
              title='Фото соединения шлангов в точке №4 после замены'
              fieldName={
                MechanicalStepCoolingSystemCheckFields.hoseConnectionReplacementPhotoPoint4
              }
            />
          </Card>
        </FormGroup>

        <DeviationsFormFields
          compact={compact}
          detectedFieldName={MechanicalStepCoolingSystemCheckFields.deviations}
          commentFieldName={MechanicalStepCoolingSystemCheckFields.deviationsComment}
          className={styles.deviationsFields}
        />
      </StepForm>
    </div>
  )
}
